'use client';

import { Requester } from '@/lib/Requester';
import { Endpoints } from '@/lib/Endpoints';
import { GenericResponse } from '@/models/GenericResponse';
import { PaymentType } from '@/models/PaymentType';
import { CheckoutPage } from '@/lib/checkoutRoutes';

export function CheckoutPaymentProblem({
  paymentType,
  paymentTypes,
}: {
  paymentType: number;
  paymentTypes: PaymentType[];
}) {
  async function updatePaymentPreset() {
    try {
      const activeType = paymentTypes.find((type) => type.value === paymentType);
      if (!activeType?.hasOtherOptions) {
        return;
      }

      const body = {
        paymentTypeId: activeType?.hasOtherOptions,
      };

      await Requester.post<GenericResponse<any>>(Endpoints.UPDATE_PAYMENT_PRESET, body);

      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }

  if (paymentTypes.length === 0) {
    return null;
  }

  const activeType = paymentTypes.find((type) => type.value === paymentType);
  if (activeType?.hasOtherOptions) {
    return (
      <div className="text-xs italic mt-8">
        Ödeme problemi yaşıyorum.{' '}
        <span className="cursor-pointer text-hzc_purple_500" onClick={() => updatePaymentPreset()}>
          Farklı bir yöntemle ödeme yapmak istiyorum.
        </span>
      </div>
    );
  }

  return null;
}
